import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";

const updateWaitTime = async (data) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found");
  const user = JSON.parse(userDetails);

  const response = await axios.post(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=updateWaitTime&companyid=${user.companyid}&teststepid=${data.tsid}&waittime=${data.time}&testcaseid=${data.tcid}`,
    {
      tsid: data.tsid,
      tcid: data.tcid,
      time: data.time
    }
  );

  return response.data;
};

const useUpdateWaitTimeMutation = (options = {}) => {
  return useMutation({
    mutationFn: updateWaitTime,
    ...options,
  });
};

export default useUpdateWaitTimeMutation; 